import { render } from "./Legals.vue?vue&type=template&id=3ce7c8f6"
import script from "./Legals.vue?vue&type=script&lang=js"
export * from "./Legals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__